import HasErrorsMixin from 'vue-core/mixins/HasErrorsMixin';
import HttpInterceptor from 'vue-core/auth/HttpInterceptor';

export default {
  mixins: [ HasErrorsMixin ],

  props: {
    value: {
      type: Object,
      required: true
    },

    disabled: {
      type: Boolean,
      default: false
    },

    errors: {
      type: Array,
      default: undefined
    }
  },

  methods: {
    propertyChanged(prop, value) {
      const obj = { ...this.value };
      obj[prop] = value;
      this.$emit('input', obj);
    },

    isAdministrator() {
      const loggedUser = HttpInterceptor.loggedUser;
      return loggedUser && loggedUser.administrator;
    },

    // =========================================================================
    // Utilities for data-table
    // =========================================================================

    columnProps({ prop, key, label }, furtherProps = {}) {
      return (item, index) => ({
        label,
        disabled: this.disabled,
        value: item[key],
        error: this.findError(prop + '[' + index + '].' + key),
        ...furtherProps
      });
    },

    columnEvents({ prop, key }) {
      return (item, index) => ({
        input: (v) => {
          const arr = [ ...this.value[prop] ];
          arr[index] = { ...item };
          arr[index][key] = v;
          this.propertyChanged(prop, arr);
        }
      });
    },
  }
}
